module.exports = __webpack_public_path__ + "img/质量保函.65de0779.png";